import React, { useEffect, useState } from "react";
import "./Home.scss";
import SlideShow from "../../components/slideshow/SlideShow";
import ProductCat from "../../components/productCat/ProductCat";
import GoogleMap from "../../components/googleMap/GoogleMap";
import FeaturedProducts from "../../components/FeaturedProducts/FeaturedProducts";
import { useNavigate } from "react-router-dom";
import CardSlid from "../../components/FeaturedProducts/CardSlid";
import MobileSlideShow from "../../components/slideshow/MobileSlideShow";
import sale from "../../img/video/CHRISTMAS-OFFER.jpg";
import { Link } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleProduct = (price) => {
    navigate("/shop", { state: { price } });
  };

  return (
    <div className="__fw">
      <div className="home">
        <div className="__hero">
          {isMobile ? <MobileSlideShow /> : <SlideShow />}
        </div>
      </div>
      <div className="__mw">
        {/* <div className="offer_wrp">
          <div className="Img_wrp" onClick={() => handleProduct("3")}>
            <img src={require("../../img/aed3.jpg")} alt="" />
          </div>
          <div className="Img_wrp" onClick={() => handleProduct("5")}>
            <img src={require("../../img/aed5.jpg")} alt="" />
          </div>
          <div className="Img_wrp" onClick={() => handleProduct("10")}>
            <img src={require("../../img/aed10.jpg")} alt="" />
          </div>
          <div className="Img_wrp" onClick={() => handleProduct("15")}>
            <img src={require("../../img/aed15.jpg")} alt="" />
          </div>
        </div> */}
        {/* <div className="cont_wrp">
          <FeaturedProducts type="offers" />
        </div> */}
        <div className="cont_wrp">
          <div className="___heading_main">
            <h3>
              Top Selling <em>products</em>
            </h3>
          </div>
          <CardSlid type="topSelling" />
        </div>
        <div className="cont_wrp">
          <div className="___heading_main">
            <h3>
              Roastery <em>items</em>
            </h3>
          </div>
          <CardSlid type="roastery" />
        </div>
        <Link to={"/offers"}>
          <div className="offer_wrp_ban">
            <img  src={sale} alt="offers banner" />
          </div>
        </Link>

        <div className="offer_wrp">
          <div className="Img_wrp" onClick={() => handleProduct("3")}>
            <img src={require("../../img/new_images/3.jpg")} alt="" />
          </div>
          <div className="Img_wrp" onClick={() => handleProduct("5")}>
            <img src={require("../../img/new_images/5.jpg")} alt="" />
          </div>
          <div className="Img_wrp" onClick={() => handleProduct("10")}>
            <img src={require("../../img/new_images/10.jpg")} alt="" />
          </div>
          <div className="Img_wrp" onClick={() => handleProduct("15")}>
            <img src={require("../../img/new_images/15.jpg")} alt="" />
          </div>
        </div>

        {/* <div>
            <h5>luxury chocolates catalogue</h5>
          </div>
          <ProductCat /> */}
      </div>
      <GoogleMap />
    </div>
  );
};

export default Home;
